const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  errorLogs: state => state.errorLog.logs,
  goodid: state => state.goods.goodid,
  couponid: state => state.goods.couponid,
  goodlist: state => state.goods.goodlist,
  coupongoodlist: state => state.goods.coupongoodlist,
  stockgoodid: state => state.goods.stockgoodid
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js